import React, { Component } from 'react';
import _ from 'lodash';
import ElementDialogWrapper from '../ElementDialogWrapper/ElementDialogWrapper';
import VideoDialog from './VideoDialog';

export default class VideoDialogWrapper extends Component {
  render() {
    const { open, panelName, panelProps } = this.props;
    const { newElement, selectedElement, elementType, elementPosition } = panelProps;

    return (
      <ElementDialogWrapper
        newElement={newElement}
        panelName={panelName}
        updateElementProps={{selectedElement: selectedElement}}
        addElementProps={{elementType: elementType, elementPosition: elementPosition}}
      >
        <VideoDialog
          open={open}
          newElement={newElement}
          selectedElement={selectedElement}
        />
      </ElementDialogWrapper>
    );
  }
}

